<div class="checkboxToggle js-element--checkboxContainer">
    <div>
        <input type="checkbox" name="Service Provider" id="serviceProvider">
        <label for="serviceProvider">Service Provider</label>
    </div>
    <div>
        <input type="checkbox" name="Associate" id="associate">
        <label for="associate">Associate</label>
    </div>
</div>